import { useEffect, useState } from 'react';
import { Discord } from '@velocity-exchange/icons';
import ErrorPageBackdrop from 'src/components/ErrorPageBackdrop';
import Button from 'src/components/primitives/Button/Button';
import Link from 'src/components/primitives/Link/Link';
import { VELOCITY_DISCORD_URL } from 'src/constants/constants';

const PREVIEW_LINK_SUFFIX = 'drift-web.vercel.app';

export default function ErrorPage({ error }: { error?: any }) {
	const [isPreviewLink, setIsPreviewLink] = useState(false);

	useEffect(() => {
		setIsPreviewLink(window.location.hostname.includes(PREVIEW_LINK_SUFFIX));
	}, []);

	return (
		<>
			<div className="relative grid h-full place-items-center overflow-hidden bg-main-bg px-lg">
				{/** Decorative glow / grid backdrop. */}
				<ErrorPageBackdrop className="pointer-events-none absolute top-[calc(50%-84px)] left-1/2 aspect-[760/336] w-[min(760px,120vw)] -translate-x-1/2 -translate-y-1/2" />

				<div className="z-1 flex flex-col items-center gap-y-md text-center">
					<h1 className="z-1 text-[3rem] font-bold text-text-default sm:text-[5.625rem]">
						Wh<span className="text-green-600">oops!</span>
					</h1>

					<div className="z-1 flex w-[min(100%,488px)] flex-col items-center gap-y-2xl text-center text-text-default">
						<p className="typo-heading-h4 sm:typo-heading-h3">
							Failed to complete action
						</p>
						<p className="typo-body-sm text-text-secondary">
							Something&apos;s gone wrong with the action you&apos;ve performed.
							Go back to the Homepage and try again. If this problem persists,
							please reach out on{' '}
							<Link href={VELOCITY_DISCORD_URL} openInNewTab rightIcon="none">
								Discord
							</Link>
							.
						</p>
						<div className="flex items-center gap-x-lg">
							<Link
								href={VELOCITY_DISCORD_URL}
								openInNewTab
								rightIcon="none"
								className="grid size-[42px] place-items-center rounded-full text-text-default outline -outline-offset-1 outline-button-primary-bg outline-solid hover:bg-button-selector"
							>
								<Discord size={20} />
								<span className="sr-only">Join our Discord</span>
							</Link>
							<Button as="a" href="/" size="lg">
								Go to Homepage
							</Button>
						</div>
					</div>
				</div>
			</div>

			{/** Used to debug on mobile phones where access to console is not available */}
			{isPreviewLink && !!error && (
				<div className="typo-body-xs text-text-default">
					<details>
						<summary>Error details</summary>
						{JSON.stringify(error)}
					</details>
				</div>
			)}
		</>
	);
}
